/*
 * Copyright (c) 2017 Mailtech.cn, Ltd. All Rights Reserved.
 */

'use strict';

(module.exports = function loadPolyfill(init) {
    //
    // Browser compatibility: Basic / Full
    // +--------------------------------+---------+--------------+-------+-------------------+-------+--------------+
    // | Feature                        | Chrome  | Firefox      | Edge  | Internet Explorer | Opera | Safari       |
    // +--------------------------------+---------+--------------+-------+-------------------+-------+--------------+
    // | ES6: Promise                   | 32      | 29 / 37      | (Yes) | No                | 19    | 7.1 / 10     |
    // | ES7: Array.prototype.includes  | 47      | 43           | 14    | No                | 34    | 9            |
    // +--------------------------------+---------+--------------+-------+-------------------+-------+--------------+
    if (!Array.prototype.includes) {
        // noinspection JSUnresolvedFunction
        require.ensure([], function () {
            require('./');
            init && init();
        }, 'polyfill');
    } else {
        init && init();
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./framework/cui/src/polyfill/load.js
 ** module id = 67
 ** module chunks = 7
 **/